import {
  createSpot,
  updateSpot,
  getSpotById,
  getSpots,
  getProvinces,
  getCities,
} from "@/services/admin/spots";

export const state = {
  spots: [],
  currentSpot: {
    name: "",
    type: "clinic",
    reservationOnline: "",
    phone: "",
    whatsapp: "",
    address: "",
    province: "",
    city: "",
    postCode: "",
    googleMapsPoint: {
      latitude: "",
      longitude: "",
    },
    operationalHours: [{ day: "", openingHours: "" }],
    subTitleID: "",
    subTitleEN: "",
    imageGallery: [],
    descriptionID: "",
    descriptionEN: "",
    status: "",
  },
  formData: {
    name: "",
    type: "clinic",
    reservationOnline: "enable",
    phone: "",
    whatsapp: "",
    address: "",
    province: "",
    city: "",
    postCode: "",
    googleMapsPoint: {
      latitude: "",
      longitude: "",
    },
    operationalHours: [{ day: "", openingHours: "" }],
    subTitleID: "",
    subTitleEN: "",
    imageGallery: [],
    descriptionID: "",
    descriptionEN: "",
    status: "active",
  },
  isUploading: false,
  provinces: [],
  cities: [],
};

export const mutations = {
  SET_SPOTS(state, spots) {
    state.spots = spots;
  },
  SET_CURRENT_SPOT(state, spot) {
    state.currentSpot = spot;
    state.formData = { ...spot };
  },
  UPDATE_FORM_DATA(state, { field, value }) {
    state.formData = {
      ...state.formData,
      [field]: value,
    };
  },
  SET_UPLOADING_STATUS(state, status) {
    state.isUploading = status;
  },
  RESET_FORM(state) {
    state.formData = {
      name: "",
      type: "clinic",
      reservationOnline: "enable",
      phone: "",
      whatsapp: "",
      address: "",
      province: "",
      city: "",
      postCode: "",
      googleMapsPoint: {
        latitude: "",
        longitude: "",
      },
      operationalHours: [{ day: "", openingHours: "" }],
      subTitleID: "",
      subTitleEN: "",
      imageGallery: [],
      descriptionID: "",
      descriptionEN: "",
      status: "active",
    };
  },
  SET_PROVINCES(state, provinces) {
    state.provinces = provinces;
  },
  SET_CITIES(state, cities) {
    console.log("Cities data to be set in state:", cities);
    state.cities = cities;
  },
};

export const actions = {
  async fetchSpots({ commit }) {
    try {
      const response = await getSpots(1, 1000);
      commit("SET_SPOTS", response.data.data);
    } catch (error) {
      console.error("Failed to fetch spots:", error);
      throw error;
    }
  },

  async loadSpotById({ commit }, id) {
    try {
      const response = await getSpotById(id);

      // Make sure we're accessing the correct data structure
      const spotData = response.data;

      // Map the API response to our form data structure
      const spot = {
        name: spotData.name,
        type: spotData.type,
        reservationOnline: spotData.isOnlineReservation ? "enable" : "disable",
        phone: spotData.phone,
        whatsapp: spotData.whatsapp,
        address: spotData.address,
        province: spotData.provinceId.toString(),
        city: spotData.cityId.toString(),
        postCode: spotData.postcode,
        googleMapsPoint: {
          latitude: spotData.latitude,
          longitude: spotData.longitude,
        },
        operationalHours: spotData.operationTime.map((time) => ({
          day: time.day,
          openingHours: time.openHours,
        })),
        subTitleID: spotData.subtitleId,
        subTitleEN: spotData.subtitleEn,
        imageGallery: spotData.imageGallery || [],
        descriptionID: spotData.descriptionId,
        descriptionEN: spotData.descriptionEn,
        status: spotData.status,
      };

      commit("SET_CURRENT_SPOT", spot);
    } catch (error) {
      console.error("Failed to load spot:", error);
      throw error;
    }
  },

  async saveSpot({ commit }, { id = null, formData }) {
    try {
      let response;
      if (id) {
        response = await updateSpot(id, formData);
      } else {
        response = await createSpot(formData);
      }

      // Check if the response was successful
      if (response.success) {
        commit("RESET_FORM");
        return true;
      } else {
        throw new Error(response.message || "Failed to save spot");
      }
    } catch (error) {
      console.error("Failed to save spot:", error);
      throw error;
    }
  },

  updateFormField({ commit }, { field, value }) {
    commit("UPDATE_FORM_DATA", { field, value });
  },

  async fetchProvinces({ commit }) {
    try {
      const provinces = await getProvinces();
      commit("SET_PROVINCES", provinces);
    } catch (error) {
      console.error("Failed to fetch provinces:", error);
      throw error;
    }
  },

  async fetchCities({ commit }, provinceId) {
    try {
      const cities = await getCities(provinceId);
      console.log("Fetched cities:", cities);
      commit("SET_CITIES", cities);
    } catch (error) {
      console.error("Failed to fetch cities:", error);
      throw error;
    }
  },
};

export const getters = {
  isNameDuplicate: (state) => (name) => {
    return state.spots.some(
      (spot) => spot.name.toLowerCase() === name.toLowerCase()
    );
  },
  provinces: (state) => state.provinces,
  cities: (state) => state.cities,
};
